module.exports = __webpack_public_path__ + "img/sofort.65171910.svg";